exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tips[data-v-960e799c] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  margin: 4px 0 0;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/appsetting/appopen/part/update/Add.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;CACjB","file":"Add.vue","sourcesContent":["\n.tips[data-v-960e799c] {\r\n  color: #999;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  margin: 4px 0 0;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-960e799c","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/appsetting/appopen/part/update/Add.vue
// module id = GBu3
// module chunks = 0